import PropTypes from 'prop-types'
import { branch, compose, getContext, renderNothing } from 'recompose'
import { connect } from 'react-redux'
import { get } from 'lodash'
import { withChart, withQueryParams } from 'src/composables'
import ValueLineChart from 'src/charts/ValueLineChart'
import { selectAVMGraphVisibility } from 'src/store/selectors/avmHistory'
import { selectHomeData } from 'src/store/selectors/home'

const composeWithHomeData = compose(
  connect(state => {
    const home = selectHomeData(state)

    if (!home) {
      return {}
    }

    return {
      data: state.avmHistory[home.id],
      showChart: selectAVMGraphVisibility(state)[home.id]
    }
  }),
  branch(({ showChart }) => !showChart, renderNothing)
)

const composeWithoutHomeData = compose(
  withQueryParams,
  connect((state, { id }) => {
    const { avmHistory = [], avms = [] } = get(
      state,
      ['homePreview', id, 'data'],
      {}
    )

    return {
      data: avmHistory,
      showChart: avms.length > 3
    }
  })
)

const ChartContainer = compose(
  getContext({
    withCurrentHomeData: PropTypes.bool
  }),
  branch(
    ({ withCurrentHomeData }) => withCurrentHomeData,
    composeWithHomeData,
    composeWithoutHomeData
  ),
  withChart(ValueLineChart)
)

export default ChartContainer
